import { description } from "platform";
import React, { useState } from "react";
import "./metricsCounter.css";
import { BsArrowDownRight, BsArrowUpRight } from "react-icons/bs";

export default function MetricsCountCard({
  count,
  text,
  previosMonthDataAvailable,
  subCountExists,
  subCount1,
  subCount2,
  showPercentData,
  alignTitleCenter,
  showTotals
}) {
  const [perecntToAbsToggle, setPercentToAbsToggle] = useState(showPercentData);
  // const increasing =
  //   count && count.percentChange > 0
  //     ? "true"
  //     : count && count.percentChange == 0
  //     ? "zero"
  //     : "false";

  const absChange = previosMonthDataAvailable ? count.current - count.previous :0;
  const increasing = absChange > 0 ? "true" : absChange == 0 ? "zero" : "false";

  const undefinedPercent = count.previous == 0;
  return (
    <div
      className={`profile_metrics_ui_card profile_metrics_counter ${
        showPercentData ? "cursor-pointer" : ""
      }`}
      onMouseEnter={() => showPercentData && setPercentToAbsToggle(false)}
      onMouseLeave={() => showPercentData && setPercentToAbsToggle(true)}
    >
      <div className="profile_metrics_counter_main_center">
       
        <div
          className={
            alignTitleCenter
              ? "profile_metrics_counter_text_center"
              : "profile_metrics_counter_text"
          }
        >
          {text}
        </div>
        {showPercentData ? (
          <div>
            {!perecntToAbsToggle ? (
              <div>
                {" "}
                <h4 className="profile_metrics_counter_heading">
                  {count.currentPercent}%
                </h4>
              </div>
            ) : (
              <h4 className="profile_metrics_counter_heading">
                {showTotals ? count.previous + count.current : count.current}
              </h4>
            )}
          </div>
        ) : (
          <h4 className="profile_metrics_counter_heading">{count.current}</h4>
        )}
      </div>

      <div className="profile_metrics_counter_prev_and_percentages">
        <div className="pmc_percent">
          <div
            // className={`pmc_percent_num_${
            //   previosMonthDataAvailable
            //     ? undefinedPercent
            //       ? "undp"
            //       : increasing
            //     : "nocolor"
            // }`}
            className={`pmc_percent_num_${
              previosMonthDataAvailable ? increasing : "nocolor"
            }`}
          >
            {["false", "true"].includes(increasing) ? (
              increasing == "true" ? (
                <BsArrowUpRight size={16} className="mr-1 f_W_500" />
              ) : (
                <BsArrowDownRight size={16} className="mr-1 f_W_500" />
              )
            ) : (
              ""
            )}
            {/* {previosMonthDataAvailable
              ? count.previous != 0
                ?  Math.abs(count.percentChange)+"%"
                : "-"
              : "-"} */}
            {previosMonthDataAvailable ? absChange : "-"}
          </div>
          <div className="pmc_percent_text">Change</div>
        </div>
        <div className="pmc_prev">
          {showPercentData ? (
            <div>
              {!perecntToAbsToggle ? (
                <div>
                  {" "}
                  <div className="pmc_prev_num">
                    {previosMonthDataAvailable
                      ? count.previousPercent + "%"
                      : "0"}
                  </div>
                </div>
              ) : (
                <div className="pmc_prev_num">
                  {previosMonthDataAvailable ? count.previous : "0"}
                </div>
              )}
            </div>
          ) : (
            <div className="pmc_prev_num">
              {previosMonthDataAvailable ? count.previous : "0"}
            </div>
          )}

          <div className="pmc_prev_text">Prev. Month</div>
        </div>
      </div>

      {/* {subCountExists ? (
        <div className="profile_metrics_counter_other_sub_counts">
          {subCount1 ? (
            <div className="pmc_subdiv">
              <div>{subCount1.current}</div>
              <div>{subCount1.text}</div>
            </div>
          ) : (
            ""
          )}

          {subCount2 ? (
            <div className="pmc_subdiv">
              <div>{subCount2.current}</div>
              <div>{subCount2.text}</div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )} */}
    </div>
  );
}
